import { mobile, tablet } from "components/templates/Breakpoints";
import { types } from "react-bricks/frontend";
import styled from "styled-components";

export type VerticalPadding = "none" | "s" | "m" | "l";

export const getVerticalPadding = (paddingVertical: VerticalPadding) => {
  switch (paddingVertical) {
    case "none":
      return "0";
    case "s":
      return "3rem";
    case "m":
      return "6.875rem";
    case "l":
      return "10rem";
    default:
      return "0";
  }
};

export const verticalPadSideProp = {
  name: "paddingVertical",
  label: "Padding",
  type: types.SideEditPropType.Select,
  shouldRefreshStyles: true,
  selectOptions: {
    display: types.OptionsDisplay.Select,
    options: [
      { label: "None", value: "none" },
      { label: "Small", value: "s" },
      { label: "Medium", value: "m" },
      { label: "Large", value: "l" },
    ],
  },
};

export const VerticalPaddingWrapper = styled.div<{
  paddingVertical: VerticalPadding;
  backgroundColor?: string;
}>`
  padding-top: ${(p) => getVerticalPadding(p.paddingVertical)};
  padding-bottom: ${(p) => getVerticalPadding(p.paddingVertical)};

  ${({ backgroundColor }) => backgroundColor && `background-color: ${backgroundColor};`}

  ${tablet} {
    padding-top: ${(p) => reduceValue(p.paddingVertical, 1.5)};
    padding-bottom: ${(p) => reduceValue(p.paddingVertical, 1.5)};
  }

  ${mobile} {
    padding-top: ${(p) => reduceValue(p.paddingVertical, 2)};
    padding-bottom: ${(p) => reduceValue(p.paddingVertical, 2)};
  }
`;

const reduceValue = (val: VerticalPadding, divideBy: number) => {
  const value = getVerticalPadding(val);
  if (!value) {
    return value;
  }
  return (Number(value.replace("rem", "")) / divideBy).toFixed(2) + "rem";
};
